import { BASE_URL } from '@core';
import type { InsuranceDocumentType } from '../models/types';

export const SUBAGENT_AGREEMENT_SHOW_ID = 3603;

export const INSURANCE_DOCUMENT_TYPES = {
  KEY_INFORMATION_DOCUMENT: 'KEY_INFORMATION_DOCUMENT',
  FINANCIAL_RISK_INSURANCE_RULES: 'FINANCIAL_RISK_INSURANCE_RULES',
  POLICY_DRAFT: 'POLICY_DRAFT',
  PERSONAL_DATA_CONSENT: 'PERSONAL_DATA_CONSENT',
} as const;

export const INSURANCE_DOCUMENTS: ReadonlyArray<{
  type: InsuranceDocumentType;
  title: string;
}> = [
  {
    type: INSURANCE_DOCUMENT_TYPES.KEY_INFORMATION_DOCUMENT,
    title: 'Ключевой информационный документ (КИД)',
  },
  {
    type: INSURANCE_DOCUMENT_TYPES.FINANCIAL_RISK_INSURANCE_RULES,
    title: 'Правила страхования',
  },
  {
    type: INSURANCE_DOCUMENT_TYPES.POLICY_DRAFT,
    title: 'Условия страхования',
  },
  {
    type: INSURANCE_DOCUMENT_TYPES.PERSONAL_DATA_CONSENT,
    title: 'Согласие на обработку персональных данных',
  },
];

/**
 * Константы для API документации
 */
export const API_DOCS = {
  AGREEMENT: `${BASE_URL}/api/docs/agreement_cs`,
  OFFER: `${BASE_URL}/api/docs/offer_cs`,
  POLITIC: `${BASE_URL}/api/docs/politic_cs`,
  CONDITIONS: `${BASE_URL}/api/docs/conditions`,
  COMPANY_INFO: `${BASE_URL}/api/docs/companyInfo`,
  PARTNERDOC: `${BASE_URL}/api/docs/partnerdoc`,
  INSURANCE: (insDoc: InsuranceDocumentType) => `${BASE_URL}/api/docs/insurance?insDoc=${insDoc}`,
};
